import PropTypes from 'prop-types'
import React from 'react'

import FormSection from '../../shared/components/FormSection'
import TextInput from '../../shared/components/TextInput'
import TextArea from '../../shared/components/TextArea'

const InformationFormSection = ({
  validationObj,
  phone,
  fax,
  website,
  email,
  description,
  show,
  readOnly,
  onChange,
  fieldSpecs
}) => {
  return (
    <FormSection
      title="2. Informationen"
      show={show}
    >

      <TextInput
        size={4}
        name="phone"
        value={phone}
        placeholder="09987 654321-11"
        // helpText="Bitte nur eine Telefonnummer angeben. Am besten die, die für die Buchung am sinnvollsten ist."
        isValid={validationObj.phone}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.phone}
      />

      <TextInput
        size={4}
        name="fax"
        value={fax}
        placeholder="09987 654321-11"
        isValid={validationObj.fax}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.fax}
      />

      <TextInput
        name="website"
        value={website}
        isValid={validationObj.website}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.website}
      />

      <TextInput
        name="email"
        value={email}
        isValid={validationObj.email}
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.email}
      />

      <hr />

      <TextArea
        name="description"
        value={description}
        maxLength={1000}
        isValid={validationObj.description}
        // helpText="Max. 1000 Zeichen inkl. Leerzeichen; Suchwörter verwenden;
        // Struktur: Museumsgeschichte, Gebäude, Sammlung, Alleinstellungsmerkmal"
        disabled={readOnly}
        onChange={onChange}
        {...fieldSpecs.description}
      />
    </FormSection>
  )
}

InformationFormSection.propTypes = {
  description: PropTypes.string,
  email: PropTypes.string,
  fax: PropTypes.string,
  phone: PropTypes.string,
  show: PropTypes.bool,
  website: PropTypes.string,
}

export { InformationFormSection as default }



// WEBPACK FOOTER //
// ./src/museum/components/02-InformationFormSection.js